(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 700px)').matches;

  /* Prikker under swipe-karruseller på mobil */
  if (mobile) {
    ['.glt-picker', '.glt-steps', '.glt-videos'].forEach(function (s) {
      Array.prototype.forEach.call(document.querySelectorAll(s), function (track) {
        var n = track.children.length;
        if (n < 2) return;
        var hint = document.createElement('div');
        hint.className = 'glt-swipe-hint';
        hint.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < n; i++) hint.appendChild(document.createElement('i'));
        track.parentNode.insertBefore(hint, track.nextSibling);
        var dots = hint.children;
        function mark() {
          var w = track.children[0].getBoundingClientRect().width + 14;
          var idx = Math.round(track.scrollLeft / w);
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) idx = n - 1;
          for (var j = 0; j < n; j++) dots[j].className = j === idx ? 'on' : '';
        }
        var t;
        track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(mark); }, { passive: true });
        mark();
      });
    });
  }

  if (reduce) return;

  /* Ind-animationer: kun elementer, der starter under skærmen */
  if ('IntersectionObserver' in window) {
    var sel = mobile
      ? '.glt-section .glt-head, .glt-picker, .glt-steps, .glt-videos, .glt-split > *, .glt-trust__grid, .glt-cta > *, .glt-faq details, .glt-partner, .glt-home, .glt-form-layout > *'
      : '.glt-section .glt-head, .glt-pick, .glt-step, .glt-split > *, .glt-trust__item, .glt-video-wrap, .glt-cta > *, .glt-faq details, .glt-partner, .glt-home, .glt-form-layout > *';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.classList.add('is-in');
        var d = parseInt(el.style.getPropertyValue('--glt-delay'), 10) || 0;
        setTimeout(function () {
          el.classList.remove('glt-reveal', 'is-in');
          el.style.removeProperty('--glt-delay');
        }, 750 + d);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.95) return;
      var i = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--glt-delay', (Math.min(i, 4) * 60) + 'ms');
      el.classList.add('glt-reveal');
      io.observe(el);
    });
  }

  /* Hero: afdæmpet parallax */
  var hero = document.querySelector('.glt-hero');
  if (!hero) return;
  var inner = hero.querySelector('.glt-hero__inner');
  var media = hero.querySelectorAll('.glt-hero__video, .glt-hero__poster');
  var ticking = false;
  function update() {
    ticking = false;
    var h = hero.offsetHeight || 1;
    var y = Math.max(0, Math.min(window.scrollY || window.pageYOffset, h));
    var p = y / h;
    if (inner) {
      inner.style.transform = 'translate3d(0,' + (y * 0.1).toFixed(1) + 'px,0)';
      inner.style.opacity = String(Math.max(0, 1 - p * 0.6).toFixed(3));
    }
    for (var i = 0; i < media.length; i++) {
      media[i].style.transform = 'translate3d(0,' + (y * 0.15).toFixed(1) + 'px,0)';
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
